<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">ACKNOWLEDGMENTS</h2>
<p class="normal">Thanks to Ken and Phyllis Reeves, who own Patchwork Plus. They have given me many teaching opportunities to test my patterns in classes. They have also given me a flexible schedule.</p>
<p class="normal">It has been a delight to work with the staff members at C&amp;T Publishing. Without their help, I could never have written this book. Their good ideas and expertise have been invaluable.</p>
<p class="normal">Another thanks to the generosity of fabric companies: P&amp;B Textiles, RJR Fabrics, and Michael Miller Fabrics.</p>
<p class="normal">I also want to thank Joyce Horst for helping in writing “My Quilting Journey.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781607054221_04_ack.vue?ce122d62